import React, {Component} from "react";
import {Translate} from "react-localize-redux";
import {Button, Card, CardHeader, CardBody} from "reactstrap";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import ProductDialog from "../../../ProductDialog";
import CategorySelector from "../../../CategorySelector";
import TranslationViewer from "../../../../03-components/TranslationViewer";
import Alert from "../../../../03-components/Alert";
import {getEnv} from "../../../../env";
import "./style.css";
import {
  ACTIONS,
  loadProducts,
  addProduct,
  deleteProduct,
  updateProduct,
  swapProductOrders,
} from "../../../../01-actions/adminProducts";
import {UpdownComponent} from "../../../../03-components/Updown/updown";

const getItemFromArrayById = (array, id) => {
  return array.find((item) => item._id === id);
};

class ProductsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertAck: true,
      openDialog: false,
      dialogOptions: null,
      selectedProductId: null,
      selectedCategoryId: null,
    };

    this.openMainDialog = this.openMainDialog.bind(this);
    this.handleCategorySelect = this.handleCategorySelect.bind(this);
    this.handleProductDialog = this.handleProductDialog.bind(this);
    this.showProductDetail = this.showProductDetail.bind(this);
    this.props.loadProducts({});
  }

  openMainDialog(visible, options) {
    this.setState({openDialog: visible, dialogOptions: options});
  }

  showProductDetail(product) {
    return () => {
      this.setState({selectedProductId: product._id});
    };
  }

  handleProductDialog(options, values) {
    //-- dispatch the correct actions
    this.setState({openDialog: false, alertAck: false});
    if (options && options.editMode) {
      //-- update
      this.props.updateProduct({
        _id: options.value._id,
        categoryId: values.categoryId,
        name: values.name,
        img1: values.img1,
        img2: values.img2,
        description: values.description,
        isFeatured: values.isFeatured,
      });
    } else {
      //-- create new
      this.props.addProduct({
        categoryId: values.categoryId,
        name: values.name,
        description: values.description,
        img1: values.img1,
        img2: values.img2,
        isFeatured: values.isFeatured,
      });
    }
  }

  handleCategorySelect(categoryId) {
    this.setState({selectedCategoryId: categoryId});
  }

  render() {
    let selectedProduct = this.props.products.find(
      (p) => p._id === this.state.selectedProductId,
    );
    let filteredProducts = this.props.products
      .filter((p) => p.categoryId === this.state.selectedCategoryId)
      .sort((p1, p2) => p1.order - p2.order);

    return (
      <Translate>
        {({translate}) => (
          <div className="pages-admin-products">
            <div className="header">Products</div>
            <div className="content">
              <Button
                className={
                  this.props.status === ACTIONS.PRODUCT_ADDING
                    ? "progress-button"
                    : ""
                }
                disabled={this.props.status === ACTIONS.PRODUCT_ADDING}
                color="primary"
                onClick={() => {
                  this.openMainDialog(true);
                }}
              >
                Add product
              </Button>
              <div className="margin-bottom-20px" />
              <div className="row">
                <div className="col-12 col-sm-6">
                  <CategorySelector
                    withProductCount={true}
                    onSelected={this.handleCategorySelect}
                  />
                  <div className="margin-bottom-20px" />
                  {this.state.selectedCategoryId &&
                    filteredProducts &&
                    !filteredProducts.length && (
                      <div className="text-center">No product found</div>
                    )}
                  {filteredProducts && filteredProducts.length ? (
                    <div className="products-list">
                      {filteredProducts &&
                        filteredProducts.map((product, index) => (
                          <div
                            key={index}
                            className={
                              "product-item" +
                              (product === selectedProduct ? " selected" : "")
                            }
                          >
                            <UpdownComponent
                              upDisabled={index === 0}
                              downDisabled={
                                index === filteredProducts.length - 1
                              }
                              onClick={(isUp) => {
                                this.props.swapProductOrders({
                                  id1: filteredProducts[index]._id,
                                  id2:
                                    filteredProducts[index + (isUp ? -1 : 1)]
                                      ._id,
                                });
                              }}
                            />
                            <div className={"product-img"}>
                              {product.img1 && (
                                <img
                                  src={
                                    getEnv("S3_ASSETS_BUCKET") +
                                    "/" +
                                    product.img1 +
                                    "?" +
                                    Date.now()
                                  }
                                />
                              )}
                            </div>
                            <div
                              onClick={this.showProductDetail(product)}
                              className="product-name"
                            >
                              {product.name}
                            </div>
                            <div className="product-featured">
                              {product.isFeatured && (
                                <i className={"fas fa-star"} />
                              )}
                            </div>
                          </div>
                        ))}
                    </div>
                  ) : null}
                </div>
                <div className="col-12 col-sm-6">
                  {selectedProduct && (
                    <Card className="product-detail">
                      <CardHeader>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="font-weight-bold">Product detail</div>
                          <fieldset
                            disabled={
                              [
                                ACTIONS.PRODUCT_REMOVING,
                                ACTIONS.PRODUCT_UPDATING,
                              ].indexOf(this.props.status) >= 0
                            }
                          >
                            <Button
                              className={
                                "margin-right-5px " +
                                ([
                                  ACTIONS.PRODUCT_UPDATING,
                                  ACTIONS.PRODUCT_REMOVING,
                                ].indexOf(this.props.status) >= 0
                                  ? "progress-button"
                                  : "")
                              }
                              color="danger"
                              onClick={() => {
                                this.setState({
                                  alertAck: false,
                                  showRemoveConfirm: true,
                                  removeItemId: selectedProduct._id,
                                });
                              }}
                              size="sm"
                            >
                              <i className="fas fa-trash" />
                            </Button>
                            <Button
                              className={
                                "" +
                                ([
                                  ACTIONS.PRODUCT_UPDATING,
                                  ACTIONS.PRODUCT_REMOVING,
                                ].indexOf(this.props.status) >= 0
                                  ? "progress-button"
                                  : "")
                              }
                              onClick={() => {
                                this.openMainDialog(true, {
                                  editMode: true,
                                  value: selectedProduct,
                                });
                              }}
                              color="primary"
                              size="sm"
                            >
                              <i className="fas fa-pencil-alt" />
                            </Button>
                          </fieldset>
                        </div>
                      </CardHeader>
                      <CardBody>
                        <div className="d-flex flex-row justify-content-between">
                          <div className="margin-bottom-10px">Name</div>
                          <div>{selectedProduct.name}</div>
                        </div>
                        <div className="d-flex flex-row justify-content-between">
                          <div className="margin-bottom-10px">Category</div>
                          <div>
                            <TranslationViewer
                              value={
                                getItemFromArrayById(
                                  this.props.categories,
                                  selectedProduct.categoryId,
                                ).name
                              }
                            />
                          </div>
                        </div>
                        <div>
                          <div className="margin-bottom-10px">Description</div>
                          <Card className="product-description-wrapper">
                            <TranslationViewer
                              value={selectedProduct.description}
                            />
                          </Card>
                        </div>
                        <div>
                          <div className="margin-bottom-10px margin-top-10px">
                            Photos
                          </div>
                          <div className="d-flex">
                            {selectedProduct.img1 && (
                              <Card className="product-photo">
                                <img
                                  src={
                                    getEnv("S3_ASSETS_BUCKET") +
                                    "/" +
                                    selectedProduct.img1 +
                                    "?" +
                                    Date.now()
                                  }
                                  alt="profile"
                                />
                              </Card>
                            )}
                            {selectedProduct.img2 && (
                              <Card className="product-photo">
                                <img
                                  src={
                                    getEnv("S3_ASSETS_BUCKET") +
                                    "/" +
                                    selectedProduct.img2 +
                                    "?" +
                                    Date.now()
                                  }
                                  alt="detail"
                                />
                              </Card>
                            )}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  )}
                </div>
              </div>
            </div>
            <div className="margin-bottom-40px" />
            {this.state.openDialog && (
              <ProductDialog
                onOK={this.handleProductDialog}
                onClose={() => {
                  this.openMainDialog(false);
                }}
                options={this.state.dialogOptions}
              />
            )}
            {!this.state.alertAck && this.state.showRemoveConfirm && (
              <Alert
                type="danger"
                cancelTitle={translate("cancel")}
                okTitle={translate("ok")}
                onClose={() => {
                  this.setState({alertAck: true, showRemoveConfirm: false});
                }}
                onOK={() => {
                  this.setState({
                    alertAck: true,
                    showRemoveConfirm: false,
                    selectedProduct: null,
                  });
                  this.props.deleteProduct({
                    _id: this.state.removeItemId,
                  });
                }}
                header={translate("confirm")}
                content={translate("remove-product-confirm")}
              />
            )}
            {!this.state.alertAck && this.props.error && (
              <Alert
                okTitle={translate("ok")}
                onOK={() => {
                  this.setState({alertAck: true});
                }}
                header={translate("error")}
                content={translate("errors." + this.props.error.code)}
              />
            )}
          </div>
        )}
      </Translate>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    categories: store.adminCategories.categories,
    status: store.adminProducts.status,
    products: store.adminProducts.products,
    error: store.adminProducts.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {loadProducts, addProduct, updateProduct, deleteProduct, swapProductOrders},
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage);



// WEBPACK FOOTER //
// ./src/04-containers/_pages/Admin/Products/index.js